import { createAction } from "@reduxjs/toolkit";
import { action } from "../actions";
// the following are more concerned with controlling a call
/**
 * Call creation action - keys under payload
 * @param target - the username of the remote user
 * @param targetEndpointId
 * @param dir - direction is "incoming" or "outgoing"
 * @param callId - the callId, created locally or received
 */
export const callCreateRequest = createAction(action("CALL_CREATE_REQUEST"));
export const clearAllCalls = createAction(action("CALL_CLEAR_ALL"));
// the following are in-call specific
export const callAnswer = createAction(action("CALL_ANSWER"));
export const callHold = createAction(action("CALL_HOLD"));
export const callTerminate = createAction(action("CALL_TERMINATE"));
export const callIceCandidate = createAction(action("CALL_ICE_CANDIDATE"));
export const callIceStateChange = createAction(action("CALL_ICE_STATE_CHANGE"));
export const callConnectionStateChange = createAction(action("CALL_CONNECTION_STATE_CHANGE"));
export const callStateAction = createAction(action("CALL_STATE"));
//# sourceMappingURL=actions.js.map